import { useQuery } from "react-query";
import { createApiWithPath } from "../../client";
import { PeopleConnectionListResponse } from "../../types/people-connection";

export const usePeopleConnections = () => {
  return useQuery<PeopleConnectionListResponse>(
    ["people-connections"],
    async () => {
      const response = await createApiWithPath("people-connection").get("");
      return response.data;
    },
  );
};
